<!-- Narrow screens: the button that opens the drawer. It sits outside .cfp-drawer so it stays in the page flow. -->
<button #drawerTrigger type="button" class="cfp-trigger" *ngIf="drawerMode"
        [attr.aria-expanded]="drawerOpen" [attr.aria-controls]="bodyId" (click)="openDrawer()">
  <mat-icon aria-hidden="true">tune</mat-icon>
  <span>{{ label }}</span>
  <span class="cfp-trigger__count" *ngIf="activeCount">{{ activeCount }}<span class="cfp-sr"> active</span></span>
</button>
<div class="cfp-backdrop" *ngIf="drawerMode && drawerOpen" (click)="closeDrawer()" aria-hidden="true"></div>

<div class="cfp-drawer" [cdkTrapFocus]="drawerMode && drawerOpen" [attr.role]="drawerMode ? 'dialog' : null" [attr.aria-modal]="drawerMode && drawerOpen ? 'true' : null"
     [attr.aria-label]="drawerMode ? label : null">
  <div class="cfp-head">
    <ng-container *ngIf="!drawerMode; else drawerHead">
      <button type="button" class="cfp-toggle" role="switch" [class.cfp-toggle--compact]="compactToggle"
              [attr.aria-checked]="!collapsed" [attr.aria-controls]="bodyId" [attr.aria-label]="label"
              [matTooltip]="collapsed ? 'Show ' + label.toLowerCase() : ''" matTooltipPosition="right" (click)="toggle()">
        <mat-icon class="cfp-toggle__icon" aria-hidden="true">tune</mat-icon>
        <span class="cfp-toggle__label">{{ label }}</span>
        <span class="cfp-switch" aria-hidden="true"><span class="cfp-switch__thumb"></span></span>
      </button>
    </ng-container>
    <ng-template #drawerHead>
      <span class="cfp-title"><mat-icon aria-hidden="true">tune</mat-icon>{{ label }}</span>
    </ng-template>
    <div class="cfp-actions" *ngIf="!collapsed"><ng-content select="[cfpHeadAction]"></ng-content></div>
    <button #drawerClose type="button" class="cfp-close" *ngIf="drawerMode" aria-label="Close filters" (click)="closeDrawer()">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>

  <!-- Switched off: one icon per section; a dot marks a section with a value applied. -->
  <div class="cfp-rail" role="toolbar" aria-orientation="vertical" *ngIf="collapsed" [attr.aria-label]="label + ' sections'">
    <button type="button" class="cfp-rail__btn" *ngFor="let s of sections; trackBy: trackByKey"
            [class.is-active]="isActive(s.key)" [matTooltip]="s.label + (isActive(s.key) ? ' (filter applied)' : '')"
            matTooltipPosition="right" [attr.aria-label]="s.label + (isActive(s.key) ? ', filter applied' : '')"
            (click)="openSection(s.key)">
      <mat-icon aria-hidden="true">{{ s.icon }}</mat-icon>
      <span class="cfp-rail__dot" *ngIf="isActive(s.key)"></span>
    </button>
  </div>

  <div class="cfp-body" [id]="bodyId"><ng-content></ng-content></div>
</div>
